import { useEffect, useRef, useState } from 'react';

export function useDebouncedState<T>(value: T, delay: number) {
    const [debounced, setDebounced] = useState(value);
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => setDebounced(value), delay);
        // value тут завжди останнє
        // debounce завжди підтягує актуальне
        return () => {
            if (timer.current) clearTimeout(timer.current);
        };
    }, [value, delay]);

    return debounced;
}
